import * as Yup from 'yup'
import { SQUARE_LOGO } from '../../../../fields'
import { listOfImagesShape } from '../../../../validations'

export const validationSchema = Yup.object({
  [SQUARE_LOGO]: listOfImagesShape
})
